<template>
  <div>
    <p>本サイトは「混雑情報を提供による「密」回避を促す行動変容に関する実証実験」の実証実験用ウェブアプリです。</p>
    <p class="text-center">本サイト使用中の位置情報を取得します。
    <span class="text-red">位置情報の利用を「許可」するようにお願いします。</span>
    取得されたデータは、個人を特定できない形式に加工され、研究目的以外に使用しません。</p>
    <p>ご利用に際し、利用規約とプライバシーポリシーをご確認ください。<br/>
    利用規約とプライバシーポリシーは下のボタンをタップしてご覧ください。</p>
  </div>
</template>

<script>

export default {
  name: 'consent-sentence'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Molecules/ConsentSentence.vue